const zh_CN = {
    'menu.cve': 'Vehicle Threat Intelligence',
    'user.theme': '切换主题',
    'user.exit': '退出登录'
};

export default zh_CN;

